import { FullscreenExitOutlined, FullscreenOutlined } from '@ant-design/icons'
import { Button, Tooltip } from 'antd'
import { type FC, useEffect, useState } from 'react'
import screenfull from 'screenfull'
import { CONTENT_DOM_ELEMENT } from './AppContentApi'

export const FullscreenButton: FC<{ element?: () => HTMLElement }> = ({ element }) => {
  const [active, setActive] = useState(screenfull.element != null)

  useEffect(() => {
    if (screenfull.isEnabled) {
      const listener = () => setActive(screenfull.element != null)
      screenfull.on('change', listener)
      return () => {
        screenfull.off('change', listener)
      }
    }
  }, [])

  return screenfull.isEnabled ? (
    <Tooltip title={active ? 'Vollbild beenden' : 'Vollbild'}>
      <Button
        icon={active ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
        onClick={() => screenfull.toggle(element?.() ?? CONTENT_DOM_ELEMENT())}
        disabled={!screenfull.isEnabled}
      />
    </Tooltip>
  ) : undefined
}
